<template>
  <div class="AdelantosNominaSupervisor">
    <h1>Adelantos de nómina supervisores</h1>

  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
export default {
  name: "AdelantosNominaSupervisor",
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      msg: "AdelantosNominaSupervisor",
      autocompleteValue: null,
      editorTexto: "hola"
    };
  }
};
</script>


// WEBPACK FOOTER //
// AdelantosNominaSupervisor.vue?7326d557